var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendPatientEnrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2437 18.8149C18.9575 19.6297 18.6664 20.3336 18.4233 20.7547C17.375 22.5711 16.2936 17.3446 16.2936 17.3446C16.2936 17.3446 11.0671 16.2632 12.8834 15.2145C14.4161 14.3299 19.6985 12.809 20.4365 13.2017C20.6516 13.6063 20.2925 15.3746 19.7779 17.1434",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.1382L18.5 15.1382",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0349 8.21518C14.0349 9.29647 13.6053 10.3335 12.8407 11.0981C12.0761 11.8626 11.0391 12.2922 9.95786 12.2922C8.87657 12.2922 7.83957 11.8626 7.07499 11.0981C6.3104 10.3335 5.88086 9.29647 5.88086 8.21518C5.88086 7.1339 6.3104 6.0969 7.07499 5.33231C7.83957 4.56772 8.87657 4.13818 9.95786 4.13818C11.0391 4.13818 12.0761 4.56772 12.8407 5.33231C13.6053 6.0969 14.0349 7.1339 14.0349 8.21518Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 19.948C3.57422 17.865 5.21822 15.271 9.95722 15.271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPatientEnrollIcon);
export default __webpack_public_path__ + "static/media/send-patient-enroll-icon.b8d2aa957da945f54d188b38421eab1f.svg";
export { ForwardRef as ReactComponent };